<div class="tutorial-dialog" [ngStyle]="getDialogPosition()">
    <h2>{{ title }}</h2>
    <p class="tutorial-description">{{ description }}</p>
    <span class="cont">0{{ currentStep }}/0{{ totalSteps }}</span>
    <div class="tutorial-footer">
        <button (click)="onContinue()">{{currentStep !== 4 ? 'Continuar': 'Listo'}}</button>
        <span class="skip" (click)="currentStep !== 4 ? onSkip(): onReset()">{{currentStep !== 4 ? 'Saltar tutorial': 'Volver a empezar'}}</span>
    </div>
</div>